import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_setup.isMobile
    ? _c(_setup.InfoLayout, {
        attrs: {
          "current-path": _setup.reverseFull({ name: "socials" }),
          "is-policy": false,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "title",
              fn: function () {
                return [
                  _vm._v(
                    "\n    " +
                      _vm._s(_setup.t("Соцсети", _setup.options)) +
                      "\n  "
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  _c("main", [
                    _c("section", [
                      _c(
                        "div",
                        {
                          class: _setup.isMobile
                            ? "px-2 py-6"
                            : "column-count-3 ga-4 mb-n4",
                        },
                        _vm._l(_setup.socials, function (social, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              class: _setup.isMobile
                                ? ""
                                : "break-inside-avoid rounded elevation-1 pa-4 mb-4",
                            },
                            [
                              _setup.isMobile && index !== 0
                                ? _c(VDivider, { staticClass: "my-6" })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex align-center gc-4",
                                  class: _setup.isMobile ? "mb-4" : "mb-2",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "border-sm rounded-circle pa-1",
                                    },
                                    [
                                      _c(VImg, {
                                        attrs: {
                                          alt: social.title,
                                          src: social.logo,
                                          width: "48",
                                          height: "48",
                                          contain: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-subtitle-1 text--text mb-1",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(social.title) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex align-start",
                                        class: _setup.isMobile
                                          ? "gc-4"
                                          : "flex-column",
                                      },
                                      _vm._l(social.links, function (link) {
                                        return _c(
                                          "div",
                                          {
                                            key: link.text,
                                            staticClass:
                                              "d-inline-flex align-center gc-2",
                                          },
                                          [
                                            link.logo
                                              ? _c(VImg, {
                                                  attrs: {
                                                    src: link.logo,
                                                    width: "16",
                                                    height: "16",
                                                    contain: "",
                                                  },
                                                })
                                              : link.icon
                                              ? _c("span", {
                                                  staticClass:
                                                    "ui-icon-fz-smaller",
                                                  class: [
                                                    link.icon,
                                                    link.iconClasses,
                                                  ],
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "text-link-2 primary--text link-decoration-underline",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _setup.handleClickLink(
                                                      link.href
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(link.text) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  class: _setup.isMobile
                                    ? "text-body-1 text--text"
                                    : "text-body-2 text-secondary--text",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(social.description) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ]),
                  ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          3944558343
        ),
      })
    : _c("main", [
        _c("section", [
          _c(
            "div",
            {
              class: _setup.isMobile
                ? "px-2 py-6"
                : "column-count-3 ga-4 mb-n4",
            },
            _vm._l(_setup.socials, function (social, index) {
              return _c(
                "div",
                {
                  key: index,
                  class: _setup.isMobile
                    ? ""
                    : "break-inside-avoid rounded elevation-1 pa-4 mb-4",
                },
                [
                  _setup.isMobile && index !== 0
                    ? _c(VDivider, { staticClass: "my-6" })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex align-center gc-4",
                      class: _setup.isMobile ? "mb-4" : "mb-2",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "border-sm rounded-circle pa-1" },
                        [
                          _c(VImg, {
                            attrs: {
                              alt: social.title,
                              src: social.logo,
                              width: "48",
                              height: "48",
                              contain: "",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "div",
                          { staticClass: "text-subtitle-1 text--text mb-1" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(social.title) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "d-flex align-start",
                            class: _setup.isMobile ? "gc-4" : "flex-column",
                          },
                          _vm._l(social.links, function (link) {
                            return _c(
                              "div",
                              {
                                key: link.text,
                                staticClass: "d-inline-flex align-center gc-2",
                              },
                              [
                                link.logo
                                  ? _c(VImg, {
                                      attrs: {
                                        src: link.logo,
                                        width: "16",
                                        height: "16",
                                        contain: "",
                                      },
                                    })
                                  : link.icon
                                  ? _c("span", {
                                      staticClass: "ui-icon-fz-smaller",
                                      class: [link.icon, link.iconClasses],
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "text-link-2 primary--text link-decoration-underline",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _setup.handleClickLink(link.href)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(link.text) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: _setup.isMobile
                        ? "text-body-1 text--text"
                        : "text-body-2 text-secondary--text",
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(social.description) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              )
            }),
            0
          ),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }